// OIDC configuration for the PCS IdP — Pattern B (public SPA client, Authorization
// Code + PKCE). Driven by REACT_APP_* (CRA bakes these at build time, so restart the
// dev server after changing them).
//
// When REACT_APP_AUTH_MODE is not "oidc", OIDC is OFF and the app keeps the existing
// dummy-login participant picker — so this integration is completely inert until it is
// explicitly enabled per environment. See IDP_INTEGRATION.md.
const authority = process.env.REACT_APP_OIDC_AUTHORITY || 'https://idp-dev.pcsretirement.com';
const clientId = process.env.REACT_APP_OIDC_CLIENT_ID || 'node-frontend';

export const OIDC_ENABLED = (process.env.REACT_APP_AUTH_MODE || 'dummy').toLowerCase() === 'oidc';

// Which token claim names the participant. MUST match the backend's
// OIDC_PRINCIPAL_CLAIM. Defaults to the standard OIDC subject claim.
export const OIDC_PRINCIPAL_CLAIM = process.env.REACT_APP_OIDC_PRINCIPAL_CLAIM || 'sub';

const origin = typeof window !== 'undefined' ? window.location.origin : '';

const scope = process.env.REACT_APP_OIDC_SCOPE || 'openid profile offline_access roles node-api';

// oidc-client-ts UserManager settings. PKCE is automatic for response_type "code".
export const oidcConfig = {
  authority,
  client_id: clientId,
  // Must match the RedirectUri registered in the IdP EXACTLY (scheme/host/port/path).
  redirect_uri: process.env.REACT_APP_OIDC_REDIRECT_URI || `${origin}/auth/callback`,
  post_logout_redirect_uri:
    process.env.REACT_APP_OIDC_POST_LOGOUT_REDIRECT_URI || `${origin}/login`,
  response_type: 'code',
  scope,
  // Silent renew needs a refresh token (offline_access). Only enable it when that
  // scope is actually granted — otherwise oidc-client-ts schedules renewals that
  // can't succeed (background errors) and can churn the stored token. Re-enabling
  // offline_access (Option B) turns silent renew back on automatically.
  automaticSilentRenew: scope.split(/\s+/).includes('offline_access'),
};

// The localStorage key oidc-client-ts uses to persist the signed-in user. The API
// client reads the access token from here synchronously in its request interceptor.
export const OIDC_STORAGE_KEY = `oidc.user:${authority}:${clientId}`;
